import _ from "lodash";

import store from "../reduxStore";
import IMeta, { ISorting } from "models/IMeta";
import { PAGE_SIZE } from "constants/.";

const getFilterPrefix = (url) =>
  _.includes(url, "&$filter=") ? " and " : "&$filter=";

const getSortings = (meta) => {
  let sortings = _.flattenDeep([meta.defaultSorting]) as ISorting[];
  const customSorting: ISorting = {
    orderByKey: meta.orderByKey!,
    orderByType: meta.orderByType!,
  };

  if (meta.orderByKey) {
    sortings = _.filter(
      sortings,
      ({ orderByKey }) => orderByKey !== _.replace(meta.orderByKey!, /\./g, "/")
    );
    sortings = [customSorting, ...sortings];
  }

  return sortings;
};

export const generateSorting = (orderMeta) => {
  let url = "";

  if (_.isArray(orderMeta)) {
    url = orderMeta
      .map((e) => concatStrings(e.orderByKey, e.orderByType))
      .join(",");
  } else {
    url = concatStrings(orderMeta.orderByKey, orderMeta.orderByType);
  }

  return url;
};

const concatStrings = (str1, str2) =>
  [_.replace(str1, /\./g, "/"), str2].join(" ");

const generateQuery = (meta: IMeta | null, customerField?, rawFilterQuery?) => {
  const pageSize = _.get(meta, "pageSize") || PAGE_SIZE;
  const customerId = _.isEmpty(store.getState().app.currentCustomer)
    ? 0
    : store.getState().app.currentCustomer.Id;

  let url =
    meta && !meta.findAll ? `&$inlinecount=allpages&$top=${pageSize}` : "";

  if (meta && meta.currentPage) {
    url += `&$skip=${meta.currentPage * pageSize}`;
  }

  if (meta && meta.orderByKey && !meta.defaultSorting) {
    url += `&$orderby=${generateSorting(meta)}`;
  } else if (meta && meta.defaultSorting) {
    const sortings = getSortings(meta);
    url += `&$orderby=${generateSorting(sortings)}`;
  }

  if (meta && meta.searchString) {
    url += `${getFilterPrefix(url)}(${meta.searchString})`;
  }
  if (rawFilterQuery) {
    url += `${getFilterPrefix(url)}(${rawFilterQuery})`;
  }

  if (meta && meta.unread) {
    url += `${getFilterPrefix(url)}${
      meta.readPath || "Read"
    } eq ${!meta.unread}`;
  }

  if (customerField) {
    url += `${getFilterPrefix(url)}${customerField} eq ${customerId}`;
  }

  return url;
};

export default generateQuery;
